import { Component } from 'react';
import type { ErrorInfo, ReactNode } from 'react';
import { reportError } from '../../lib/errorReport';

interface State {
  failed: boolean;
}

/**
 * Catches a crash while drawing the page, reports it to the audit log and
 * shows a way back, instead of leaving a blank screen.
 */
export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { failed: false };

  static getDerivedStateFromError(): State {
    return { failed: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    reportError('render', error, info.componentStack ?? undefined);
  }

  render() {
    if (!this.state.failed) return this.props.children;

    return (
      <div className="route-splash" role="alert">
        <h1 className="crash-title">Something went wrong on this page</h1>
        <p className="crash-text">It has been reported. Reload to carry on from where you were.</p>
        <button type="button" className="crash-btn" onClick={() => window.location.reload()}>
          Reload
        </button>
      </div>
    );
  }
}
